import React, { useEffect } from 'react';
import Template from '../../Template/Template';
import img from 'src/assets/images/lock-v2.svg';
import { STEP_LINK_BANK } from '../../../AddBank/AddBank';
import { dispatchPageLoad } from 'src/redux/utils/analytics-helper';

const EverifyAccountLockout = ({ setBankProgress, isSalesforceRep }) => {
  useEffect(() => {
    dispatchPageLoad('VerificationLockedManual');
  }, []);
  if (isSalesforceRep) {
    return (
      <Template
        image={img}
        header={`This verification method is currently locked.`}
        msg={`Due to previous attempts we have on record, you are currently locked out of this bank verification method for 72 hours. To continue, try signing in through your bank directly.`}
      />
    );
  } else {
    return (
      <Template
        image={img}
        header={`This verification method is currently locked.`}
        msg={`Due to previous attempts we have on record, you are currently locked out of this bank verification method for 72 hours. To continue, try signing in through your bank directly.`}
        nextButton={`Sign In with Bank Information`}
        nextDestination={''}
        onNextClick={() => setBankProgress(STEP_LINK_BANK)}
      />
    );
  }
};

export default EverifyAccountLockout;
